import PureFlagRenderer from './renderer/index.tsx';
import withFlagService from './with-flag-service/index.tsx';

export const FlagRenderer = withFlagService(PureFlagRenderer);
